import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IDefaultResult } from './IJoinUs';
import * as backEnd from '../Shared/globalVar';

@Injectable({
  providedIn: 'root'
})
export class BlogService {

  constructor(
    private http: HttpClient
  ) {

  }

  public getDisplayedNewsletters(): Observable<IDefaultResult> {
    const url = backEnd.apiUrlV1 + 'newsletter/displayed';
    console.log(url)
    return this.http.get<IDefaultResult>(url);
  }
}
